export default __webpack_public_path__ + "static/media/משוגעים.5a1b3442.mp3";